import styled from "styled-components";

export const SuccessModalWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 36px;
    .tick-mark {
        @media (max-width: 576px) {
            width: 150px;
        }
    }

    .details {
        max-width: 300px;
        width: 100%;
        h2 {
            font-size: 24px;
            line-height: 28px;
            font-weight: 500;
            text-align: center;
            @media (min-width: 576px) {
                font-size: 28px;
                line-height: 32px;
            }
        }
        p {
            font-size: 16px;
            font-weight: 300;
            line-height: 20px;
            text-align: center;
            @media (min-width: 576px) {
                font-size: 18px;
                line-height: 22px;
            }
        }
    }
    button {
        height: 52px;
    }
`;
